import { render } from "./CopyrightComponent.vue?vue&type=template&id=2d44ba91&scoped=true"
import script from "./CopyrightComponent.vue?vue&type=script&lang=js"
export * from "./CopyrightComponent.vue?vue&type=script&lang=js"

import "./CopyrightComponent.vue?vue&type=style&index=0&id=2d44ba91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d44ba91"]])

export default __exports__